import React, { Component } from 'react';
import {
    Grid, Row, Col, FormGroup, FormControl, InputGroup, Tooltip, OverlayTrigger, Modal
} from 'react-bootstrap';
import Card from '../../components/Card/Card.jsx';
import UserCard from '../../components/Card/UserCard.jsx';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import avatarM from "../../assets/img/faces/M.png";
import avatarF from "../../assets/img/faces/F.png";
import header from "../../assets/img/headers/card-header0.jpg";
import SweetAlert from "react-bootstrap-sweetalert";
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import ContactService from "../../services/ContactService";
import UserService from "../../services/UserService";

const remove = (<Tooltip id="remove_tooltip">Eliminar</Tooltip>);
const details = (<Tooltip id="remove_tooltip">Detalles</Tooltip>);
const share = (<Tooltip id="remove_tooltip">Compartir</Tooltip>);
const edit = (<Tooltip id="remove_tooltip">Editar</Tooltip>);

class Main extends Component{
  constructor(props){
    super(props);
    this.state = {
        showShare: false,
        multipleSelect: null,
        alert: null,
        contacts: [],
        users:[],
        contactToShare: null,
    };
    this.permission = [
      'Administrador Sistema',
      'Asistente Técnico de Gestión',
      'Coordinador',
      'Administrador Sistema',
    ].includes(this.props.currentUser.roles[0]);
    this.hideAlert = this.hideAlert.bind(this);
    this.successDelete = this.successDelete.bind(this);
    this.warningWithConfirmMessage = this.warningWithConfirmMessage.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getContacts = this.getContacts.bind(this);
    this.contactService = new ContactService();
    this.userService = new UserService();
    this.deleteContact = this.deleteContact.bind(this);
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }
  warningWithConfirmMessage(contact) {
    console.log(contact);
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Borrar"
          onConfirm={() => this.deleteContact(contact)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí, bórralo!"
          cancelBtnText="Cancelar"
          showCancel
        >
          ¿Esta seguro de borrar el contacto "{contact.apellido} {contact.nombre}"?
        </SweetAlert>
      )
    });
  }
  successDelete(contact) {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Deleted!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          confirmBtnText="Aceptar"
        >
          El contacto "{`${contact.nombre} ${contact.apellido}`}" ha sido borrado
        </SweetAlert>
      )
    });
  }
  successMessage(message, title) {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title={title}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  addContact() {
    this.props.history.push("/contacts/create");
  }
  editContact(id) {
    this.props.history.push("/contacts/edit/" + id);
  }
  viewContact(id) {
    this.props.history.push("/contacts/view/" + id);
  }
  shareContact(id) {
    console.log(id);
    this.setState({showShare: true, contactToShare: id, multipleSelect: null });
  }
  saveSharedContact() {
    this.contactService
      .shareContacts(this.state.contactToShare, this.state.multipleSelect)
      .then( res => {
        this.successMessage("Contacto compartido exitosamente", "Compartir");
        this.setState({showShare: false, contactToShare: null, multipleSelect: null });
      })
  }
  deleteContact(contact) {
    this.contactService
      .deleteContact(contact.id)
      .then(res => {
        this.successDelete(contact);
        this.getContacts(null);
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se eliminaba el contacto, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  getContacts(search) {
    this.contactService
      .getContacts(search)
      .then(res => {
        this.setState({ contacts: res.contacts });
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se obtenia la información de los contactos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  getUsers() {
    this.userService
      .getExternalUsers()
      .then(res => {
        let users = [];
        res.users.forEach(function(user){
          users.push( {value: user.id, label: user.username} );
        })
        //console.log(users);
        this.setState({ users: users });
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se obtenia la información de los contactos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  handleSearch(event) {
    if (event.target.value.length > 2) {
      this.getContacts(event.target.value);
    }
    if (event.target.value.length === 0) {
      this.getContacts(null);
    }
  }
  componentDidMount() {
    this.getContacts(null);
    this.getUsers();
  }
  render(){
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Contactos"
                content={
                  <div>
                    <Row>
                      <Col md={3}>
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon><i className="fa fa-search"></i></InputGroup.Addon>
                            <FormControl type="text" placeholder="Buscar..." onKeyUp={this.handleSearch}/>
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      {this.permission &&
                        <Col md={3} mdOffset={6} style={{ paddingBottom: 45 + "px"}}>
                          <Button pullRight={true} bsStyle="primary" bsSize="sm" fill wd onClick={this.addContact.bind(this)}>Nuevo</Button>
                        </Col>
                      }
                    </Row>
                    <Row>
                      {
                        this.state.contacts.map((prop,key) => {
                          console.log(prop);
                          let professionString;
                          let foto = prop.foto ? prop.foto : (prop.genero === 'M' ? avatarM : avatarF);
                          if (prop.cargo && prop.organizacion) {
                            professionString = prop.cargo + ' en ' + prop.organizacion;
                          }
                          return (
                            <Col lg={3} md={4} key={key} sm={6}>
                              <UserCard
                                bgImage={header}
                                avatar={foto}
                                name={prop.nombre + ' ' + prop.apellido}
                                profession={professionString}
                                email={prop.email}
                                expertise={prop.expertise}
                                socials={
                                  <div style={{textAlign: 'center'}}>
                                    <OverlayTrigger placement="top" overlay={details}><Button simple onClick={() => this.viewContact(prop.id)}><i className="fa fa-eye"></i></Button></OverlayTrigger>
                                    {this.permission &&
                                      <OverlayTrigger placement="top" overlay={share}><Button simple onClick={() => this.shareContact(prop.id)}><i className="fa fa-share-alt"></i></Button></OverlayTrigger>
                                    }
                                    {(this.props.currentUser.username === prop.createdby || this.props.currentUser.roles[0] === 'Administrador Sistema') &&
                                      <span>
                                        <OverlayTrigger placement="top" overlay={edit}><Button simple onClick={() => this.editContact(prop.id)}><i className="fa fa-pencil"></i></Button></OverlayTrigger>
                                        <OverlayTrigger placement="top" overlay={remove}><Button simple onClick={() => this.warningWithConfirmMessage(prop)}><i className="fa fa-trash"></i></Button></OverlayTrigger>
                                      </span>
                                    }
                                  </div>
                                }
                              />
                            </Col>
                          )
                        })
                      }
                    </Row>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>

        <Modal show={this.state.showShare} onHide={() => this.setState({showShare: false})}>
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title><i className="fa fa-share-alt"></i>&nbsp;&nbsp;&nbsp;Compartir Contacto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Seleccione uno o más usuarios</p>
                  <Select
                    placeholder="Seleccione usuarios"
                    closeOnSelect={false}
                    multi={true}
                    name="usersShareSelect"
                    value={this.state.multipleSelect}
                    options={this.state.users}
                    onChange={(value) => { this.setState({ multipleSelect: value})}}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button simple onClick={() => this.setState({showShare: false})}>Cancelar</Button>
                  <Button bsStyle="success" disabled={!this.state.multipleSelect} fill onClick={() => this.saveSharedContact()}>Guardar</Button>
                </Modal.Footer>
              </div>
            }
          />
        </Modal>

      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/views/Contacts/Main.jsx